import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import { useTranslation } from "react-i18next";

interface SwissTravelPassChildrenWithParentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function SwissTravelPassChildrenWithParentCheckbox({
  checked,
  onChange
}: SwissTravelPassChildrenWithParentCheckboxProps) {
  const { t } = useTranslation();

  return (
    <Box mb={2}>
      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
        <Checkbox
          sx={{
            "&&.PrivateSwitchBase-root": {
              paddingLeft: 0,
              paddingTop: 0
            }
          }}
          checked={checked}
          onChange={event => onChange(event.target.checked)}
        />
        <Box sx={{ fontSize: { xs: 14, sm: 14 }, fontWeight: 600, pt: 1 }}>
          {t("transport.swissTravelPass.childrenWithParentLabel")}
        </Box>
      </Box>
      <Box sx={{ fontSize: { xs: 12, sm: 13 }, color: "text.secondary", pl: 4.5 }}>
        {t("transport.swissTravelPass.childrenWithParentDescription")}
      </Box>
    </Box>
  );
}
